// observerSearchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "user_id": '',
    "user_name": '',
    "user_name_domain": '',
    "first_name": '',
    "last_name": '',
    "patient_associated": '',
    "email_address": '',
    "email_address_domain": '',
    "mobile_number_code": '',
    "mobile_number": '',
    "main_number_code": '',
    "main_number": '',
    "user_id_inverse": '',
    "user_name_inverse": '',
    "first_name_inverse": '',
    "last_name_inverse": '',
    "patient_associated_inverse": '',
    "mobile_number_inverse": '',
    "main_number_inverse": '',
    "email_address_inverse": '',
    "match": false,
    "obssearchApplied": false,

};

const observerSearchSlice = createSlice({
    name: 'observerSearch',
    initialState,
    reducers: {
        setObserverSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetObserverSearch(state) {
            return { ...initialState, obssearchApplied: false }; // Reset state and flag
        },
        setObsSearchApplied(state) {
            state.obssearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setObserverSearch, resetObserverSearch,setObsSearchApplied } = observerSearchSlice.actions;

export default observerSearchSlice.reducer;